import { IFsFileType } from "@r3f-component-data-structure";
import { FsImage } from "./image";

export class FsImage360 extends FsImage {
    type: IFsFileType.Image360 = IFsFileType.Image360
    protected _objectKey = 'img.hq'

    constructor(fileId: string, projectId: string, name: string) {
        // FsImage's constructor has already built _objectUrl from its own 'img', because this
        // subclass's field initialisers only run once super() returns. Rebuild it with 'img.hq'.
        super(fileId, projectId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/${this._objectKey}`
        this._objectUrl = url.toString()
    }
}
